module.exports = __webpack_public_path__ + "static/media/CLicon04.a4b1948c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/CLicon04.png
// module id = 731
// module chunks = 0 1